import React from 'react'

type Props = {
  label?: string
  size?: number
}

export default function Spinner({ label = 'Loading…', size = 28 }: Props) {
  return (
    <div className="spinner-wrap" role="status" aria-live="polite" aria-busy="true">
      <svg
        className="spinner"
        width={size}
        height={size}
        viewBox="0 0 50 50"
        aria-hidden="true"
      >
        {/* Track (subtle ring) */}
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="currentColor"
          opacity="0.15"
          strokeWidth="6"
        />
        {/* Animated arc */}
        <circle
          className="spinner-arc"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinecap="round"
          strokeDasharray="90 140"
        />
      </svg>
      <span className="sr-only">{label}</span>
    </div>
  )
}